// src/holidaysAdmin/index.js — public-holidays admin + annual entitlements /
// top-up (moved VERBATIM from admin.html, FE-breakup slice 3; bundled to
// dist/holidaysAdmin.js).
//
// Cluster state (HOLIDAYS_DATA, _holidaysLoadedFromDB, currentHolidayCountry)
// is PRIVATE to this module — nothing else referenced it in admin.html.
// Free names resolved at runtime from the page: DB, showToast, staffData,
// getStoreCountry, Uploads.budget.applyAnnualTopUp (module global).
//
// window bindings at the bottom keep every entry point reachable exactly as
// before (markup onclick=, showAdmin's checkAutoTopUp(), switchGroupSub's
// loadHolidaysFromDB().then(renderHolidays), and src/uploads/balances.js's
// cross-bundle loadEntitlementFields() call).

import { setHTML } from '../shared/set-html.js';   // v136.8: null-safe innerHTML for admin renders

// ── PUBLIC HOLIDAYS ──────────────────────────────────────
// HOLIDAYS_DATA is populated from DB via loadHolidaysFromDB() on tab open.
// Falls back to these hardcoded defaults if DB is empty/offline.
let HOLIDAYS_DATA = {
  UAE: [
    {date:'2026-01-01', name:'New Years Day'},
    {date:'2026-03-19', name:'Eid Al Fitr (Day 1)'},
    {date:'2026-03-20', name:'Eid Al Fitr (Day 2)'},
    {date:'2026-03-21', name:'Eid Al Fitr (Day 3)'},
    {date:'2026-04-10', name:'National Cheese Day'},
    {date:'2026-05-26', name:'Arafat Day'},
    {date:'2026-05-27', name:'Eid Al Adha (Day 1)'},
    {date:'2026-05-28', name:'Eid Al Adha (Day 2)'},
    {date:'2026-05-29', name:'Eid Al Adha (Day 3)'},
    {date:'2026-06-15', name:'Islamic New Year'},
    {date:'2026-08-24', name:'Prophets Birthday'},
    {date:'2026-11-30', name:'Commemoration Day'},
    {date:'2026-12-02', name:'National Day'},
    {date:'2026-12-03', name:'National Day (cont.)'},
  ],
  Qatar: [
    {date:'2026-01-01', name:'New Years Day'},
    {date:'2026-02-10', name:'National Sports Day'},
    {date:'2026-03-19', name:'Eid Al Fitr (Day 1)'},
    {date:'2026-03-20', name:'Eid Al Fitr (Day 2)'},
    {date:'2026-03-21', name:'Eid Al Fitr (Day 3)'},
    {date:'2026-04-10', name:'National Cheese Day'},
    {date:'2026-05-26', name:'Arafat Day'},
    {date:'2026-05-27', name:'Eid Al Adha (Day 1)'},
    {date:'2026-05-28', name:'Eid Al Adha (Day 2)'},
    {date:'2026-05-29', name:'Eid Al Adha (Day 3)'},
    {date:'2026-06-15', name:'Islamic New Year'},
    {date:'2026-08-24', name:'Prophets Birthday'},
    {date:'2026-12-18', name:'Qatar National Day'},
  ]
};
let _holidaysLoadedFromDB = false;

async function loadHolidaysFromDB() {
  try {
    const rows = await DB.holidays.list();
    if (Array.isArray(rows)) {
      // Bucket rows by country, preserving id for deletes
      const grouped = { UAE: [], Qatar: [] };
      rows.forEach(r => {
        const country = r.country || 'UAE';
        if (grouped[country]) grouped[country].push({ id: r.id, date: r.date, name: r.name });
      });
      // Only replace if DB has data; otherwise keep hardcoded defaults for first-run
      if (rows.length > 0) {
        HOLIDAYS_DATA = grouped;
        _holidaysLoadedFromDB = true;
      }
      // Cache for index.html fallback
      localStorage.setItem('elc_holidays_data', JSON.stringify(HOLIDAYS_DATA));
    }
  } catch(e) {
    console.warn('[DB] Holidays load failed, using cached/defaults:', e.message);
    try {
      const cached = localStorage.getItem('elc_holidays_data');
      if (cached) HOLIDAYS_DATA = JSON.parse(cached);
    } catch(e2) {}
  }
}
let currentHolidayCountry = 'UAE';

function switchHolidayCountry(country) {
  currentHolidayCountry = country;
  // v136.8: --green-on, the green white text reads on (5.5:1; --green is 3.5:1)
  document.getElementById('hBtnUAE').style.cssText = country==='UAE' ? 'background:var(--green-on);color:#fff;border-color:var(--green-on)' : '';
  document.getElementById('hBtnQatar').style.cssText = country==='Qatar' ? 'background:var(--green-on);color:#fff;border-color:var(--green-on)' : '';
  renderHolidays();
}

function renderHolidays() {
  const holidays = HOLIDAYS_DATA[currentHolidayCountry];
  document.getElementById('holidayListTitle').textContent = currentHolidayCountry+' Public Holidays 2026';
  const today = todayDateStr();
  setHTML('holidayList', `
    <table class="data-table">
      <thead><tr><th>Date</th><th>Holiday</th><th>Status</th><th></th></tr></thead>
      <tbody>${holidays.sort((a,b)=>a.date.localeCompare(b.date)).map((h,i) => {
        const isPast = h.date < today;
        const isToday = h.date === today;
        return `<tr>
          <td style="font-weight:600">${h.date}</td>
          <td translate="no">${escapeHtml(h.name||'')}</td>
          <td>${isToday ? '<span style="background:var(--warn-bg);color:var(--warn-deep);padding:2px 8px;border-radius:6px;font-size:11px">Today</span>' : isPast ? '<span style="color:var(--sub);font-size:11px">Past</span>' : '<span style="background:var(--ok-bg);color:var(--ok-deep);padding:2px 8px;border-radius:6px;font-size:11px">Upcoming</span>'}</td>
          <td><button onclick="removeHoliday('${currentHolidayCountry}',${i})" style="background:none;border:none;color:var(--red);cursor:pointer;font-size:13px" title="Remove">✕</button></td>
        </tr>`;
      }).join('')}</tbody>
    </table>
    <div style="margin-top:10px;font-size:12px;color:var(--sub)">${holidays.length} holidays listed · <a href="#" onclick="exportHolidays()" style="color:var(--green)">Export as CSV</a></div>`);   // v136.8: setHTML, null-safe
}

function openAddHoliday() {
  document.getElementById('addHolidayCard').style.display = 'block';
  document.getElementById('newHolCountry').value = currentHolidayCountry;
}

function persistHolidays() {
  // Cache for index.html to read (offline fallback)
  localStorage.setItem('elc_holidays_data', JSON.stringify(HOLIDAYS_DATA));
}

async function saveHoliday() {
  const date = document.getElementById('newHolDate').value;
  const name = document.getElementById('newHolName').value.trim();
  const country = document.getElementById('newHolCountry').value;
  if (!date || !name) { showToast('Fill in date and name', 'error'); return; }

  const createForCountry = async (c) => {
    try {
      const result = await DB.holidays.create({ date, name, country: c });
      const created = Array.isArray(result) ? result[0] : result;
      const id = created && created.id ? created.id : null;
      HOLIDAYS_DATA[c].push({ id, date, name });
    } catch(e) {
      console.warn('[DB] Holiday create failed:', e.message);
      // Add locally anyway so UI updates; retry sync on next load
      HOLIDAYS_DATA[c].push({ date, name });
    }
  };

  if (country === 'both') {
    await createForCountry('UAE');
    await createForCountry('Qatar');
  } else {
    await createForCountry(country);
  }
  persistHolidays();
  document.getElementById('addHolidayCard').style.display = 'none';
  renderHolidays();
  showToast('Holiday added — rota app updated automatically', 'success');
}

async function removeHoliday(country, idx) {
  if (!(await (window.uiConfirm || function (m) { return Promise.resolve(confirm(m)); })('Remove this holiday?', { danger: true, confirmLabel: 'Remove' }))) return;
  const h = HOLIDAYS_DATA[country][idx];
  if (h && h.id) {
    try { await DB.holidays.remove(h.id); }
    catch(e) { console.warn('[DB] Holiday delete failed:', e.message); }
  }
  HOLIDAYS_DATA[country].splice(idx, 1);
  persistHolidays();
  renderHolidays();
  showToast('Holiday removed', 'success');
}

function exportHolidays() {
  const rows = ['Date,Holiday,Country'];
  ['UAE','Qatar'].forEach(c => HOLIDAYS_DATA[c].forEach(h => rows.push(`${h.date},"${h.name}",${c}`)));
  const blob = new Blob([rows.join('\n')], {type:'text/csv'});
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob);
  a.download = 'elc_holidays_2026.csv'; a.click();
}

// ── BALANCES OVERVIEW ──────────────────────────────────────
// ── ANNUAL ENTITLEMENTS ───────────────────────────────────────────────────
function loadAnnualEntitlements() {
  try { return JSON.parse(localStorage.getItem('elc_annual_entitlements') || '{}'); }
  catch { return {}; }
}
function saveAnnualEntitlements() {
  const ent = {
    holiday:    parseInt(document.getElementById('entHoliday').value)    || 30,
    sick:       parseInt(document.getElementById('entSick').value)       || 14,
    toilCarry:  parseInt(document.getElementById('entToilCarry').value)  || 16,
  };
  localStorage.setItem('elc_annual_entitlements', JSON.stringify(ent));
  showToast('Annual entitlements saved — will apply on next top-up', 'success');
}

function loadEntitlementFields() {
  const ent = loadAnnualEntitlements();
  if (document.getElementById('entHoliday'))   document.getElementById('entHoliday').value   = ent.holiday   || 30;
  if (document.getElementById('entSick'))      document.getElementById('entSick').value      = ent.sick       || 14;
  if (document.getElementById('entToilCarry')) document.getElementById('entToilCarry').value = ent.toilCarry  || 16;
}

function confirmTopUp() {
  const ent = loadAnnualEntitlements();
  const hol  = parseInt(document.getElementById('entHoliday')?.value)   || ent.holiday   || 30;
  const sick  = parseInt(document.getElementById('entSick')?.value)     || ent.sick       || 14;
  const carry = parseInt(document.getElementById('entToilCarry')?.value)|| ent.toilCarry  || 16;
  const count = staffData.filter(s => s.active !== false).length;

  if (!confirm(
    `Apply annual top-up to all ${count} active staff?\n\n` +
    `• Holiday reset to ${hol} days (individual overrides kept if higher)\n` +
    `• Sick reset to ${sick} days\n` +
    `• TOIL capped at ${carry}h carry-over (excess forfeited)\n\n` +
    `This cannot be undone automatically — use individual Edit to correct mistakes.`
  )) return;

  Uploads.budget.applyAnnualTopUp(hol, sick, carry);
}

// v104.0: applyAnnualTopUp → Uploads.budget.applyAnnualTopUp
function checkAutoTopUp() {
  // Run on load — if it's Jan 1 and we haven't topped up this year, prompt
  const now = new Date();
  if (now.getMonth() !== 0 || now.getDate() !== 1) return;
  const lastTopUp = localStorage.getItem('elc_last_topup');
  if (lastTopUp && new Date(lastTopUp).getFullYear() === now.getFullYear()) return;
  // It's Jan 1 and no top-up yet this year
  setTimeout(() => {
    if (confirm('🎉 It\'s 1st January! Would you like to apply the annual balance top-up to all staff now?')) {
      const ent = loadAnnualEntitlements();
      Uploads.budget.applyAnnualTopUp(ent.holiday||30, ent.sick||14, ent.toilCarry||16);
    }
  }, 1000);
}

// Every moved function stays window-reachable (markup onclick handlers, the
// two inline call sites, and cross-bundle callers resolve via window).
window.loadHolidaysFromDB = loadHolidaysFromDB;
window.switchHolidayCountry = switchHolidayCountry;
window.renderHolidays = renderHolidays;
window.openAddHoliday = openAddHoliday;
window.persistHolidays = persistHolidays;
window.saveHoliday = saveHoliday;
window.removeHoliday = removeHoliday;
window.exportHolidays = exportHolidays;
window.loadAnnualEntitlements = loadAnnualEntitlements;
window.saveAnnualEntitlements = saveAnnualEntitlements;
window.loadEntitlementFields = loadEntitlementFields;
window.confirmTopUp = confirmTopUp;
window.checkAutoTopUp = checkAutoTopUp;
